import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { CustomPopperStyles } from '../model'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      lineHeight: 1,
      zIndex: ({ zIndex }: CustomPopperStyles) => zIndex,
      '&[data-popper-placement*="bottom-start"]': {
        marginTop: '8px !important',

        '& $arrow': {
          top: -4,
          left: 32,
          borderTopLeftRadius: 3,
        },
      },
      '&[data-popper-placement*="bottom-end"]': {
        marginTop: '8px !important',

        '& $arrow': {
          top: -4,
          right: 12,
          borderTopLeftRadius: 3,
        },
      },
      '&[data-popper-placement*="bottom"]': {
        marginTop: '8px !important',

        '& $arrow': {
          top: -4,
          left: 'calc(50% - 6px)',
          borderTopLeftRadius: 3,
        },
      },
      '&[data-popper-placement*="top"]': {
        marginBottom: '8px !important',

        '& $arrow': {
          bottom: -4,
          left: 'calc(50% - 6px)',
          borderBottomRightRadius: 3,
        },
      },
      '&[data-popper-placement*="top-start"]': {
        marginBottom: '8px !important',

        '& $arrow': {
          bottom: -4,
          left: 32,
          borderBottomRightRadius: 3,
        },
      },
      '&[data-popper-placement*="right"]': {
        marginLeft: '8px !important',

        '& $arrow': {
          left: -6,
          top: '50%',
          borderBottomLeftRadius: 3,
          transform: 'translate(0, -50%) rotate(45deg)',
        },
      },
      '&[data-popper-placement*="right-start"]': {
        marginLeft: '8px !important',

        '& $arrow': {
          left: -6,
          top: 24,
          borderBottomLeftRadius: 3,
        },
      },
      '&[data-popper-placement*="left-start"]': {
        marginLeft: '8px !important',

        '& $arrow': {
          right: -6,
          top: 24,
          borderTopRightRadius: 3,
        },
      },
    },
    paper: {
      maxWidth: ({ width }: CustomPopperStyles) => width,
      borderRadius: 8,
      padding: ({ size }: CustomPopperStyles) => {
        if (size === 'xs') {
          return '2px 8px'
        }
        if (size === 'sm') {
          return '8px 16px'
        }
        return 16
      },
      backgroundColor: theme.colors.black,
      color: theme.colors.white,
      position: 'relative',
      textAlign: ({ textAlign }: CustomPopperStyles) => textAlign || undefined,
    },
    arrow: {
      width: 12,
      height: 12,
      position: 'absolute',
      zIndex: 1,
      backgroundColor: theme.colors.black,
      transform: 'rotate(45deg)',
    },
    inner: {
      position: 'relative',
      zIndex: 2,
      whiteSpace: 'normal',
    },
  })
)
